export const DialogFormBoxContent = {
    position: 'relative',
    left: '0',
    margin: 'auto',
    marginTop: '1.25rem',
};

export const DialogFormBoxStepContent = {
    position: 'relative',
    left: '0',
    margin: 'auto',
    marginTop: '1.25rem',
    marginBottom: '1.25rem',
};

export const DialogFormBoxJustify = {
    display: 'flex',
    justifyContent: 'center',
};

export const DialogFormBoxButton = {
    display: 'flex',
    gap: '1.25rem',
    padding: '1.25rem 0',
    flexFlow: 'wrap',
};
